import { Entity } from '../objects/Entity.interface';
import { Annotation } from '../objects/Annotation.interface';
import { useState } from 'react';
import React from 'react';
import ContextMenu from '../SubComponents/ContextMenu';
import { createNewAnnotation } from '../services/Annotations.service';
import Settings from './Settings';
export type ContextMenuProps = {
    Entities: Entity [],
    Annotation: Annotation,
    AnnotationsSelected: Annotation[],
    AnnotationList:Annotation[],
    isOverAnnotation: boolean,
    isSavingNewAnnotation:boolean,
    isOpenNewDocument:boolean,
    allowContextMenu: () => void,
    showAnnotations: () => void,
    refreshData: () => void,
    handleSaveAnnoations: () => void,
    handleUpdateDocumentStats: () => void,
    handleExportAnnotations: () => void
}


var InitialContextMenuConfig  =
{
    x:0,
    y:0,
    xTranslate: '0',
    yTranslate: '0',
    show:'none'
}
var entityList: Entity[] = [];
var annotation: Annotation = createNewAnnotation(0);

export default function CorpusComponent(props:ContextMenuProps){
    
  const [contextMenu, setContexMenu] = useState<{x:number,y:number, xTranslate:string, yTranslate:string, show:string }|null>(null);


    if(props.AnnotationsSelected)
    {
      entityList = props.Entities;
      if(props.Annotation.id)
      {
        annotation = props.Annotation;
      }    
    }

    if((props.isOpenNewDocument || props.isSavingNewAnnotation) && contextMenu?.show === 'block'){
      setContexMenu(InitialContextMenuConfig);
      props.allowContextMenu();
    }

    function handleContextMenuOutScreen(onClickContext:boolean){

        var contextMenuHTMLElement:HTMLElement|null = document.getElementById('contextMenu');

        var submenuWidth = 0;
        var submenuFieldWidth = 0;

        var subMenus =  Array.from(document.getElementsByClassName('context-submenu'));
        
        if(subMenus){
          for (let i = 0; i < subMenus.length; i++) {
            const subMenu = subMenus[i] as HTMLElement;
            var name = subMenu.getAttribute('id');
            if(name )
            {
              if(subMenu.offsetWidth > 0){
              submenuWidth = subMenu.offsetWidth;
              }
            }
          }
        }

        var subMenuFields =  Array.from(document.getElementsByClassName('context-submenu-field'));
        if(subMenuFields){
          for (let i = 0; i < subMenuFields.length; i++) {
            const subMenuField = subMenuFields[i] as HTMLElement;

            if(subMenuField.offsetWidth > 0){
              submenuFieldWidth = subMenuField.offsetWidth;
            }
       
          }
        }

        var pageX= sessionStorage.getItem('menuPageX');
        var pageY= sessionStorage.getItem('menuPageY');
        var x= sessionStorage.getItem('menuX');
        var y= sessionStorage.getItem('menuY');
        var menuWidth = sessionStorage.getItem('menuWidth');
        
        if(contextMenuHTMLElement && !contextMenuHTMLElement.classList.contains('left') && pageX !==  null && pageY !==  null && x !==  null && y !==  null && menuWidth !==  null){
          if(parseInt(menuWidth) == 0){
            menuWidth = '200';
          }
          
          var menuSumTotal = parseInt(pageX) + parseInt(menuWidth) + submenuWidth + submenuFieldWidth;
          var restTotal =  menuSumTotal - window.innerWidth ;
          
          if(restTotal < 0 )
            restTotal = 0;

          var pageXResult:number = parseInt(pageX) - 270;


          if(contextMenu !== null &&  contextMenu.show === 'block' && !onClickContext){
            setContexMenu({
              x: pageXResult - restTotal,
              y: parseInt(pageY),
              xTranslate: x,
              yTranslate: y,
              show: 'block'
            });
          }
        } 
    }

    function handleContextMenu(e:any){
      e.preventDefault();
      let x:string = '0';
      let y:string = '0';
  
      const {pageX,pageY} = e;

      var pageXResult:number = pageX -270;

         
      const {innerWidth, innerHeight} = window;
  
      if(contextMenu!==null && props.isOverAnnotation && !props.isSavingNewAnnotation)
      {
        var contextMenuHTMLElement:HTMLElement|null = document.getElementById('contextMenu');
        if(contextMenuHTMLElement)
        {
          const {offsetWidth, offsetHeight} = contextMenuHTMLElement;
  
          if(pageXResult  >= (innerWidth / 2.5)){
            x = '-100%';
            contextMenuHTMLElement.classList.add('left');
          }
          else
          {
            contextMenuHTMLElement.classList.remove('left');
          }
  
  
          if(pageXResult  >= (innerWidth - offsetWidth)){
            x = '-100%';
          }
  
          if(pageY  > (innerHeight / 2.2)){
            y = '-100%';
            contextMenuHTMLElement.classList.add('top');
          }else
          {
            contextMenuHTMLElement.classList.remove('top');
          }

          sessionStorage.setItem('menuWidth', contextMenuHTMLElement.offsetWidth.toString());
        }

        sessionStorage.setItem('menuPageX', pageX);
        sessionStorage.setItem('menuPageY', pageY);
        sessionStorage.setItem('menuX', x);
        sessionStorage.setItem('menuY', y);
        
        setTimeout(() => {
              handleContextMenuOutScreen(true);
        }, 100);
       
      }

      if(props.isOverAnnotation && !props.isSavingNewAnnotation){
        setContexMenu(
          {
            x:pageXResult,
            y:pageY,
            xTranslate: x,
            yTranslate: y,
            show:'block'
          }
        );
      }
  
      if(props.isSavingNewAnnotation)
      {
        handleHideContextMenu(e);
      }
     
    }

    function handleHideContextMenu(e:any){
      e.preventDefault();
      let x:string = '0';
      let y:string = '0';
  
      const {pageX,pageY} = e;

      var pageXResult:number = pageX -270;

         
      const {innerWidth, innerHeight} = window;
  
      if(contextMenu!==null)
      {
        var contextMenuHTMLElement:HTMLElement|null = document.getElementById('contextMenu');
        if(contextMenuHTMLElement)
        {
          const {offsetWidth, offsetHeight} = contextMenuHTMLElement;
  
          if(pageXResult  >= (innerWidth / 2.5)){
            x = '-100%';
            contextMenuHTMLElement.classList.add('left');
          }
          else
          {
            contextMenuHTMLElement.classList.remove('left');
          }
  
  
          if(pageXResult  >= (innerWidth - offsetWidth)){
            x = '-100%';
          }
  
          if(pageY  > (innerHeight / 2.2)){
            y = '-100%';
            contextMenuHTMLElement.classList.add('top');
          }else
          {
            contextMenuHTMLElement.classList.remove('top');
          }

        }


       
      }
      
      
      setContexMenu(
        {
          x:pageXResult,
          y:pageY,
          xTranslate: x,
          yTranslate: y,
          show:'none'
        }
      );
    }
  
    function handleScrollCorpus(e:any) {
      e.stopPropagation();
      let documentCorpus = document.getElementById('document-container');
      var scrollpos = sessionStorage.getItem('scrollpos');
      if((!scrollpos && documentCorpus!.scrollTop > 0) || (scrollpos && documentCorpus!.scrollTop > 0))
          sessionStorage.setItem('scrollpos', documentCorpus!.scrollTop!.toString());
    }

    function handleOverCorpus(e:any) {
      e.stopPropagation();
      sessionStorage.setItem('isOverCorpus', 'true');
    }

    function handleOutCorpus(e:any) {
      e.stopPropagation();
      sessionStorage.setItem('isOverCorpus', 'false');
    }

    const handleCloseContextMenu = () => setContexMenu(InitialContextMenuConfig);
  
    window.addEventListener('resize', handleCloseContextMenu);
    

    return (
        <div id="Corpus" className="area-corpus area-tool" onClick={(e:any) => {if(props.Annotation.text != undefined && props.Annotation.text != '') handleContextMenu(e)}} onContextMenu={(e:any) => {handleHideContextMenu(e)}}>
            <div className="area-tool-container" >
                <div className="area-corpus-header">
                <div className="area-corpus-header-content">
                    
                    <Settings onChangeDocumentTextSize={props.showAnnotations} onSaveAnnotations={props.handleSaveAnnoations} onExportAnnotations={props.handleExportAnnotations}></Settings>
                    <i className="area-corpus-title" id="document-title"></i>
                </div>
                <div id="area-corpus-separator" className="separator"></div>
                </div>
                <div id="document-container"  onScroll={(e:any) => handleScrollCorpus(e)} onMouseOver={(e:any) => handleOverCorpus(e)} onMouseOut={(e:any) => handleOutCorpus(e)} className="area-corpus-content"></div>
                {contextMenu !== null && <ContextMenu x={contextMenu.x} y={contextMenu.y} displayValue={contextMenu.show} xTranslate={contextMenu.xTranslate} yTranslate={contextMenu.yTranslate} contextMenuOutScreen={handleContextMenuOutScreen} closeContextMenu={handleCloseContextMenu} showAnnotations={props.showAnnotations} refreshData={props.refreshData} updateDocumentStats={props.handleUpdateDocumentStats} entities={entityList} annotation = {annotation} annotationList={props.AnnotationList}/>}
            </div>
        </div>
    );
}